import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlyoutSettings } from '@uigy/shared/models/interfaces';
import { IconsEnum } from '@uigy/generated/icons.enum';

@Component({
    selector: 'app-header-flyout',
    templateUrl: './header-flyout.component.html',
    styleUrls: ['./header-flyout.component.scss'],
    standalone: false
})
export class HeaderFlyoutComponent {
  protected readonly IconsEnum = IconsEnum;
  public isOpen: boolean = false;

  @Input() settings!: FlyoutSettings<any>;
  @Output() selected = new EventEmitter<any>();

  constructor() {
  }

  public selectItem(value: any): void {
    if (!value.disabled) {
      this.settings.selected = value;
      this.selected.emit(value);
      this.isOpen = false;
    }
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;
  }

  public closeFlyout(): void {
    this.isOpen = false;
  }
}
